"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendUserAnalyticsData = void 0;
var _contextData = require("@ori-events/context-data");
var _analyticsProvider = require("@ori/analytics-provider");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
// Makes sure that the event is sent only once even when the react component is re-attached to the DOM multiple times
let isEventSent = false;
const SendUserAnalyticsData = ({
  periodCode
}) => {
  const {
    customerId,
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const isLoggedInUser = !isAnonymousUser;
  const {
    data
  } = (0, _globalApiClientReact.useGetCustomerInfo)(customerId, undefined, {
    swr: {
      enabled: isLoggedInUser,
      // ZMA: in case additional swr hooks (API calls) are added, use SWRConfig in AnalyticsDataInitialization component to deduplicate of this settings
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      errorRetryCount: 0
    }
  });
  const isWaitingForData = periodCode == null || !isUserVerified || isLoggedInUser && !data;
  (0, _react.useEffect)(() => {
    // The `isEventSent` flag needs to be verified here because the `useEffect` hook is called multiple times with the same values due to Strict Mode https://nextjs.org/docs/pages/api-reference/next-config-js/reactStrictMode
    if (isEventSent || isWaitingForData) {
      return;
    }
    (0, _analyticsProvider.isReady)().then(isReady => {
      if (isReady) {
        window.dispatchEvent(new CustomEvent(_contextData.Name, {
          detail: {
            customerId: data?.customerId ?? customerId,
            customerTypeId: data?.customerType?.customerTypeId ?? 0,
            consultantId: data?.consultantNumber ?? 0,
            periodId: periodCode
          }
        }));
      }
    }).catch(() => {
      isEventSent = false;
    });
    isEventSent = true;
  }, [isWaitingForData, data, customerId, periodCode]);
  return null;
};
exports.SendUserAnalyticsData = SendUserAnalyticsData;
